export enum TyreSeasonType {
  Summer = 'summer',
  Winter = 'winter',
  AllWeather = 'allweather',
  Special = 'special',
  Unknown = ''
}
